import React from "react";
import PropTypes from "prop-types";
import DataGrid, {DataGridItem} from "components/data-grid";
import {injectIntl} from "react-intl";
import withStyles from "components/with-styles";
import styles from "../styles/source-data.css.js";
import {SourceThumbnail} from "components/thumbnail";
import {SimpleButton} from "components/buttons";

const SourcePreview = ({classes, source, intl, showCamera = true}) => {
    const viewerUrl = `/source/viewer/${source.id}`;


    return (
        showCamera && (
            <DataGrid>
                <DataGridItem big>
                    {source.type === "camera" && Boolean(source.lastThumbnail) && (
                        <DataGridItem big>
                            <SourceThumbnail className={classes.sourceThumbnail} fullwidth source={source}/>
                        </DataGridItem>
                    )}
                </DataGridItem>
                <DataGridItem big className={classes.buttonContainer}>
                    <SimpleButton href={viewerUrl} icon="pageview"
                                  label={intl.formatMessage({id: "app.source.viewer"})}/>
                    <SimpleButton href={`${source.id}/disks`} icon="list"
                                  label={intl.formatMessage({id: "app.page.source.local.recordings.title"})}/>
                </DataGridItem>
            </DataGrid>
        )
    );
};

SourcePreview.propTypes = {
    /**
     * Data to represent
     **/
    source: PropTypes.object,
    /**
     * Mostrar imagen de cámara
     **/
    showCamera: PropTypes.bool,
};

export default injectIntl(withStyles(styles)(SourcePreview));
